/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import * as components from 'vuetify/components'

// Composables
import { createVuetify } from 'vuetify'
import { VCard } from 'vuetify/components'
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  aliases: {
    VLayoutCard: VCard,
    VDialogCard: VCard,
    VGlassCard: VCard,
  },
  defaults: {
    VTextField: {
      rounded: true,
      style: 'border-radius: 9999px;',
    },
    VAlert: {
      style: 'border-radius: 32px',
    },
    VSwitch: {
      falseIcon: 'mdi-close',
      trueIcon: 'mdi-check',
      color: 'primary',
    },
    VSelect: {
      rounded: true,
      style: 'border-radius: 9999px',
    },
    VAutocomplete: {
      rounded: true,
      style: 'border-radius: 9999px',
    },
    VSheet: {
      elevation: 2,
      variant: 'elevated',
      class: 'rounded-lg',
    },
    VCardTitle: {
      style: 'padding-bottom: 4px',
    },
    VDialog: {
      contentClass: 'ma-0 pa-0 d-flex justify-center align-center',
      style: 'z-index: 1100;',
    },
    VLayoutCard: {
      elevation: 2,
      variant: 'elevated',
      style: 'padding: 16px 8px; border-radius: 8px;',
    },
    VGlassCard: {
      elevation: 1,
      variant: 'elevated',
      class: 'border',
      style: 'padding: 16px 8px; border-radius: 8px; background: rgba(0,0,0,0); backdrop-filter: blur(2px)',
    },
    VDialogCard: {
      variant: 'flat',
      style: 'padding: 12px 8px; border-radius: 8px;',
    },
    VContainer: {
      style: 'padding: 32px',
    },
    VBtn: {
      style: 'border-radius: 8px;',
    },
  },
  display: {
    mobileBreakpoint: 800,
  },
  components: {
    ...components,
    //...labsComponents,
  },
  theme: {
    variations: {
      colors: ['primary', 'secondary', 'error'],
      lighten: 3,
      darken: 3,
    },
    themes: {
      light: {
        colors: {
          gradient01: '#c0c0c0',
          gradient02: '#dcdcdc',
          gradient03: '#ffffff',
          surface: '#FFFFFF',
          primary: '#254C63',
          secondary: '#9BCCE8',
          error: '#F44336',
          errorLight: '#fa817a',
          onSurface: '#000000',
          onSurfaceLowOpacity: '#0000001A',
          info: '#54B0E4',
          success: '#7EB75C',
          warning: '#ff9800',
          dark: '#373737',
          light: '#F5F5F5',
          grey: '#757575',
          'kbd-border-color': '#1b1718',
          'pattern-background-color': '#f5f5f5',
        },
      },
      dark: {
        colors: {
          gradient01: '#3a3939',
          gradient02: '#353535',
          gradient03: '#919191',
          background: '#121212',
          surface: '#212121',
          primary: '#5d7a8b',
          secondary: '#6D7DB2',
          error: '#F44336',
          onSurface: '#FFFFFF',
          onSurfaceLowOpacity: '#FFFFFF1A',
          info: '#54B0E4',
          success: '#7EB75C',
          warning: '#E7AB00',
          dark: '#373737',
          light: '#F5F5F5',
          grey: '#757575',
          'kbd-border-color': '#ecf9ff',
          'pattern-background-color': '#505050',
        },
      },
    },
  },
})
